import { ReportLevel } from "../adminReportsApiSlice";
import { reportSubLevelName } from "../adminReportsUtil";
import { TraitScoresChart } from "../shared/TraitScoresChart";
import { HolisticAndTraitScoresRow } from "./adminPerformanceReportApiSlice";

export function HolisticAndTraitScoresChart(props: {
	level: ReportLevel;
	data: HolisticAndTraitScoresRow[];
	hasData: boolean;
}) {
	return (
		<TraitScoresChart
			level={props.level}
			data={props.data}
			hasData={props.hasData}
			title={`${reportSubLevelName(props.level)} Holistic and Trait Scores`}
			yAxisDataField="name"
			totalScoreField="averageTotalScore"
			gridLeft={0}
		/>
	);
}
